import { fromJS } from 'immutable'

import { LOGIN_POST, LOGIN_UPDATE, LOGIN_ERROR } from 'actions/login'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createLoginReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_POST:
      return _postLogin(state)
    case LOGIN_UPDATE:
      return _updateLogin(state, action.payload)
    case LOGIN_ERROR:
      return _errorLogin(state, action.payload)
    default:
      return state
  }
}

const _postLogin = state => {
  return state.update('loading', () => true)
}

const _updateLogin = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorLogin = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
